@if (formController()){
<input class="peer rounded-sm relative peer shrink-0 appearance-none  border-2 border-primary  bg-white checked:bg-primary checked:border-none"
       #checkbox
       type="checkbox"
       [formControl]="formController()"
       (change)="toggle(checkbox.checked, $event)"
       [classList]="[margin()]"
       [ngClass]="{
        'checked:bg-primary': color()==='primary',
        'checked:bg-secondary': color()==='secondary',
        'w-3 h-3': size()==='small',
        'w-5 h-5': size()==='medium',
        'w-8 h-8': size()==='large'
       }"
    >
} @else {
    <input class="peer rounded-sm relative peer shrink-0 appearance-none  border-2 border-primary  bg-white checked:bg-primary checked:border-none"
           #checkbox
           type="checkbox"
           (change)="toggle(checkbox.checked, $event)"
           [classList]="[margin()]"
           [ngClass]="{
        'checked:bg-primary': color()==='primary',
        'checked:bg-secondary': color()==='secondary',
        'w-3 h-3': size()==='small',
        'w-5 h-5': size()==='medium',
        'w-8 h-8': size()==='large',
       }"
    >
}

<svg class="absolute mt-1 hidden peer-checked:block pointer-events-none self-center justify-self-center stroke-white"
     [ngClass]="{
        'w-2 h-2': size()==='small',
        'w-4 h-4': size()==='medium',
        'w-7 h-7': size()==='large',
       }"
     xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="4"
     stroke-linecap="round"
     stroke-linejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
</svg>
